__turbopack_context__.v({
  "Chip": "SgUF2a_Chip",
  "Chip--Selected": "SgUF2a_Chip--Selected",
  "Chip__Check": "SgUF2a_Chip__Check",
});
